import React from 'react';

function ShimmerBlock({ style, className = '' }) {
  return <div className={`shimmer-block ${className}`.trim()} style={style} aria-hidden />;
}

/** Full main-area skeleton while initial Cosmos/Supabase load runs. */
function AppShellShimmer() {
  return (
    <div className="app-shell-shimmer" aria-busy="true" aria-label="Loading workspace">
      <div className="app-shell-shimmer-stats">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="card app-shell-shimmer-stat">
            <ShimmerBlock style={{ height: 12, width: '55%', borderRadius: 6, marginBottom: 10 }} />
            <ShimmerBlock style={{ height: 28, width: '40%', borderRadius: 8 }} />
          </div>
        ))}
      </div>
      <div className="card app-shell-shimmer-table">
        <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border)' }}>
          <ShimmerBlock style={{ height: 18, width: 220, borderRadius: 6 }} />
        </div>
        <div className="app-shell-shimmer-rows">
          {[0, 1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="app-shell-shimmer-row">
              <ShimmerBlock style={{ height: 14, width: '28%', borderRadius: 6 }} />
              <ShimmerBlock style={{ height: 14, width: '22%', borderRadius: 6 }} />
              <ShimmerBlock style={{ height: 14, width: '18%', borderRadius: 6 }} />
              <ShimmerBlock style={{ height: 14, width: '12%', borderRadius: 6 }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export { AppShellShimmer };
